export default {
      id: "ic-nav-swiper-prev-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-nav-swiper-prev-usage",
      toString: function () {
        return this.url;
      }
    }